import { SxProps } from '@mui/material';

export const muiStyles: Record<string, SxProps> = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    height: 'calc(100% - 150px)',
  },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
};
